import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import { categories } from '@/mocks/categories';
import { getComicsByCategory } from '@/mocks/comics';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'hanman');
  const [comicList, setComicList] = useState(getComicsByCategory(slug || 'hanman'));

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      setComicList(getComicsByCategory(slug));
    }
  }, [slug]);

  const currentCategory = categories.find(c => c.slug === activeSlug);
  const categoryName = currentCategory?.name || '分类';

  return (
    <>
      <ScrollToTop />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": `虫虫漫画 - ${categoryName}专区 | 虫虫漫画大全`,
        "description": `虫虫漫画${categoryName}专区，好看的${categoryName}全集免费在线看，下拉式阅读体验，虫虫漫画平台海量${categoryName}一网打尽。`,
        "url": `https://chongchongmanga.com/category/${activeSlug}`,
        "isPartOf": {
          "@type": "WebSite",
          "name": "虫虫漫画",
          "url": "https://chongchongmanga.com"
        },
        "inLanguage": "zh-CN"
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://chongchongmanga.com" },
          { "@type": "ListItem", "position": 2, "name": `${categoryName}专区`, "item": `https://chongchongmanga.com/category/${activeSlug}` }
        ]
      }) }} />

      <Navbar />

      <main className="pt-20">
        <Breadcrumb items={[
          { label: '首页', href: '/' },
          { label: `${categoryName}专区` },
        ]} />

        {/* Category Tabs */}
        <section className="w-full px-4 md:px-6 py-6">
          <div className="flex items-center gap-2 flex-wrap">
            {categories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600'
                }`}
              >
                <i className={`${cat.icon} text-sm w-4 h-4 flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
        </section>

        {/* Category Title */}
        <section className="w-full px-4 md:px-6 py-4">
          <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
            {categoryName}专区
          </h1>
          <p className="text-sm text-foreground-500 mt-2">
            虫虫漫画{categoryName}大全，好看的{categoryName}全集免费在线看，下拉式阅读尽在虫虫漫画平台
          </p>
        </section>

        {/* Comic Grid */}
        <section className="w-full px-4 md:px-6 py-8">
          {comicList.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop="true">
              {comicList.map(comic => (
                <ComicCard key={comic.id} {...comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                <i className="ri-book-open-line text-foreground-400 text-3xl w-8 h-8 flex items-center justify-center"></i>
              </div>
              <p className="text-foreground-500 text-sm">该分类暂无漫画，请浏览其他分类</p>
              <Link to="/" className="inline-flex mt-4 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                返回首页
              </Link>
            </div>
          )}
        </section>
      </main>

      <Footer />
    </>
  );
}